import loadable from '@loadable/component';

const LithiumBatteriesLoadable = loadable(
  () => import(/* webpackChunkName: 'lithium-batteries' */ './LithiumBatteries')
);

const LithiumBatteries = () => <LithiumBatteriesLoadable />;

export default LithiumBatteries;
